import { Button, InlineMessage } from "@nexus/ui";

interface LoadErrorMessageProps {
  title: string;
  onRetry: () => void;
  description?: string;
  className?: string;
}

export function LoadErrorMessage({
  title,
  onRetry,
  description = "Check your connection and try again.",
  className,
}: LoadErrorMessageProps) {
  return (
    <InlineMessage tone="error" title={title} className={className}>
      <p>{description}</p>
      <Button variant="secondary" size="sm" className="mt-2" onClick={onRetry}>
        Try again
      </Button>
    </InlineMessage>
  );
}
